import React from 'react';
import Works from './Works';
import './work.css';

const Work = () => {
  return (
    <section className='work section' >
        
        <h2 className='section__title' id="portfolio">Portfolio</h2>
        <span className='section__subtitle'>Some of My Recent Projects</span>

        <Works />
        
    </section>
  );
};

export default Work;